import { computed } from 'vue';
import { useApp } from '@/libraries/composables/useApp';

const WEB_HEADER_PLACEHOLDER_HEIGHT = 47;
const APP_HEADER_PLACEHOLDER_HEIGHT = 1;
const WEB_HEADER_TOP_OFFSET = 1;
const APP_HEADER_TOP_OFFSET = 0;

export function usePlatformActions() {
    const { isFromApp } = useApp();
    async function handleActionByPlatform({ appAction, webAction }: {appAction: () => void, webAction: () => void | Promise<void>}) {
        if (isFromApp) {
            appAction();
        } else {
            await webAction();
        }
    }

    const headerDisplayHeight = computed(() => (isFromApp
        ? APP_HEADER_PLACEHOLDER_HEIGHT
        : WEB_HEADER_PLACEHOLDER_HEIGHT));

    const headerTopOffset = computed(() => (isFromApp
        ? APP_HEADER_TOP_OFFSET
        : WEB_HEADER_TOP_OFFSET));

    return {
        handleActionByPlatform,
        headerDisplayHeight,
        headerTopOffset,
    };
}
